export default "__VITE_ASSET__8be7fef3__"